import { extractProductId } from '../../../utils/subscriptionDetail/utils';
import { graphqlApiClient } from '../client';
import { PRODUCTS_QUERY, ProductsQueryResponse, ProductsQueryVariants } from './query';
import { Products } from './types';

export async function fetchGraphqlProducts(ids: string[]) {
  const ret: Products = {};

  try {
    const result = await graphqlApiClient<ProductsQueryResponse, ProductsQueryVariants>(
      PRODUCTS_QUERY,
      { ids }
    );

    const nodes = result.nodes;
    if (!nodes) return ret;

    return formattedProducts(nodes);
  } catch (error) {
    console.error(error);
    return ret;
  }
}

function formattedProducts(nodes: ProductsQueryResponse['nodes']) {
  const ret: Products = {};

  for (const node of nodes) {
    if (!node) continue;

    const mfs: Record<string, string> = {};
    if (node.metafields) {
      for (const mf of node.metafields) {
        if (!mf) continue;
        mfs[mf.key] = mf.value ?? '';
      }
    }

    // variants の最初の価格と画像
    const variantNode = node.variants?.nodes?.[0];
    if (!variantNode) continue;

    const id = extractProductId(node.id);
    if (!id) continue;

    const choices = createChoices(mfs['min_value'], mfs['max_value'], mfs['step']);

    ret[id] = {
      id,
      productId: node.id,
      handle: node.handle,
      variantId: variantNode.id,
      originPrice: Number(variantNode.price?.amount ?? 0),
      sku: variantNode.sku ?? '',
      weight: Number(variantNode.weight ?? 0),
      variantImage: node.images?.nodes?.[0]?.url ?? '',
      variantImages: node.images?.nodes ?? [],
      // 商品メタフィールド
      title: mfs['title'] || '',
      displayUnit: mfs['display_unit'] || '袋',
      setItems: mfs['set_items'] || '',
      specialMsg: mfs['special_msg'] || '',
      discountRate: mfs['discount_rate'] || '',
      ingredientPage: mfs['ingredient_page'] || '',
      // 新テンプレートが反映されていない商品があるため
      ingredientPageSpare: mfs['new_ingredient_page'] || '',
      choices,
    };
  }

  return ret;
}

type MfValue = string | undefined;

function createChoices(min_value: MfValue, max_value: MfValue, step_value: MfValue) {
  const min = Number(min_value ?? 1);
  const max = Number(max_value ?? 10);
  const step = Number(step_value ?? 5);
  const BORDER = 20;

  if (max < min) return Array.from({ length: 11 }, (_, i) => i);

  const values: number[] = [0];
  const upper = Math.min(max, BORDER);
  for (let i = Math.max(min, 1); i <= upper; i++) {
    values.push(i);
  }

  // 20以降（step刻み）
  if (max > BORDER) {
    const start = Math.max(min, BORDER + step);
    for (let i = start; i <= max; i += step) {
      values.push(i);
    }
  }

  return values;
}
